import { ResourceID } from "../resource_loader/resource_id.js";

/**
 * List of ResourceIDs to pack in the 3D VFX global atlas
 */
export const VFX_3D_ATLAS_CONFIG: ResourceID[] = [
  ResourceID.CircleGlow1,
  ResourceID.CircleGlow2,
  ResourceID.EllipseGlow1,
  ResourceID.SparkGlow4,
  ResourceID.WaveGlow1,
  ResourceID.WaveGlow2,
  ResourceID.ShockwaveGlow1,
  ResourceID.ShockwaveGlow2,
  ResourceID.ShockwaveGlow3,

  ResourceID.Smog,
  ResourceID.Fire,

  // Jam splash textures
  ResourceID.JamCherryTexture,
  ResourceID.JamFigTexture,
  ResourceID.JamLemonTexture,
  ResourceID.JamPlumTexture,

  // Fluid particle textures
  ResourceID.FluidParticle1,
  ResourceID.FluidParticle2,
  ResourceID.FluidParticle3,

  // Watermelon splash textures
  ResourceID.WatermelonJuiceTexture,

  ResourceID.NoisePerlinTexture,
  ResourceID.CloudNoiseTexture,
  ResourceID.VornoiNoiseTexture,

  // Glass shards
  ResourceID.GlassShard1,
  ResourceID.GlassShard2,
  ResourceID.GlassShard3,
  ResourceID.GlassShard4,

  // Splinters
  ResourceID.SplinterStone1,
  ResourceID.SplinterStone2,
  ResourceID.SplinterStone3,
  ResourceID.SplinterStone4,
  ResourceID.SplinterStone5,

  ResourceID.SplinterIce1,
  ResourceID.SplinterIce2,
  ResourceID.SplinterIce3,
  ResourceID.SplinterIce4,
  ResourceID.SplinterIce5,

  ResourceID.SplinterWood1,
  ResourceID.SplinterWood2,
  ResourceID.SplinterWood3,
  ResourceID.SplinterWood4,
  ResourceID.SplinterWood5,

  ResourceID.SplinterBrick1,
  ResourceID.SplinterBrick2,
  ResourceID.SplinterBrick3,
  ResourceID.SplinterBrick4,
  ResourceID.SplinterBrick5,

  ResourceID.SplinterColumn1,
  ResourceID.SplinterColumn2,
  ResourceID.SplinterColumn3,
  ResourceID.SplinterColumn4,
  ResourceID.SplinterColumn5,

  ResourceID.SplinterGreenBox1,
  ResourceID.SplinterGreenBox2,
  ResourceID.SplinterGreenBox3,
  ResourceID.SplinterGreenBox4,
  ResourceID.SplinterGreenBox5,

  ResourceID.SplinterPurpleBox1,
  ResourceID.SplinterPurpleBox2,
  ResourceID.SplinterPurpleBox3,
  ResourceID.SplinterPurpleBox4,
  ResourceID.SplinterPurpleBox5,

  ResourceID.SplinterPlasticBlue1,
  ResourceID.SplinterPlasticBlue2,
  ResourceID.SplinterPlasticBlue3,
  ResourceID.SplinterPlasticBlue4,
  ResourceID.SplinterPlasticBlue5,

  ResourceID.SplinterPlasticGreen1,
  ResourceID.SplinterPlasticGreen2,
  ResourceID.SplinterPlasticGreen3,
  ResourceID.SplinterPlasticGreen4,
  ResourceID.SplinterPlasticGreen5,

  ResourceID.SplinterPlasticLightBlue1,
  ResourceID.SplinterPlasticLightBlue2,
  ResourceID.SplinterPlasticLightBlue3,
  ResourceID.SplinterPlasticLightBlue4,
  ResourceID.SplinterPlasticLightBlue5,

  ResourceID.SplinterPlasticOrange1,
  ResourceID.SplinterPlasticOrange2,
  ResourceID.SplinterPlasticOrange3,
  ResourceID.SplinterPlasticOrange4,
  ResourceID.SplinterPlasticOrange5,

  ResourceID.SplinterPlasticPink1,
  ResourceID.SplinterPlasticPink2,
  ResourceID.SplinterPlasticPink3,
  ResourceID.SplinterPlasticPink4,
  ResourceID.SplinterPlasticPink5,

  ResourceID.SplinterPlasticPurple1,
  ResourceID.SplinterPlasticPurple2,
  ResourceID.SplinterPlasticPurple3,
  ResourceID.SplinterPlasticPurple4,
  ResourceID.SplinterPlasticPurple5,

  ResourceID.SplinterPlasticRed1,
  ResourceID.SplinterPlasticRed2,
  ResourceID.SplinterPlasticRed3,
  ResourceID.SplinterPlasticRed4,
  ResourceID.SplinterPlasticRed5,

  ResourceID.SplinterPlasticYellow1,
  ResourceID.SplinterPlasticYellow2,
  ResourceID.SplinterPlasticYellow3,
  ResourceID.SplinterPlasticYellow4,
  ResourceID.SplinterPlasticYellow5,
];

export const VFX_3D_ATLAS_SIZE = 2048;
